import { Helmet } from 'react-helmet-async';

/**
 * SEO Component for dynamic meta tags
 * 
 * Usage:
 * <SEO 
 *   title="Page Title" 
 *   description="Page description" 
 *   keywords="keyword1, keyword2"
 * />
 */
const SEO = ({ 
  title, 
  description, 
  keywords,
  canonicalPath = '',
  noIndex = false 
}) => {
  const baseUrl = 'https://www.plangenerator.com.au';
  const defaultTitle = 'Waste Management Plan Consultants Sydney & Melbourne | PlanGen Consulting';
  const defaultDescription = 'Specialist waste management plan consultants for Australian property developments. Operational WMPs, D&CWMPs, stormwater plans, and HAZMAT surveys for NSW & VIC councils. 8+ years experience.';
  const defaultKeywords = 'waste management plan consultant, waste management plan Sydney, waste management plan Melbourne, WMP consultant NSW, WMP consultant VIC, operational waste management plan, demolition waste management plan, stormwater management plan, Green Star waste credit';

  const fullTitle = title ? `${title} | PlanGen Consulting` : defaultTitle;
  const fullDescription = description || defaultDescription;
  const fullKeywords = keywords || defaultKeywords;
  const canonicalUrl = canonicalPath ? `${baseUrl}${canonicalPath}` : baseUrl;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={canonicalUrl} />
      
      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
    </Helmet>
  );
};

export default SEO;
